import "../../stylesheets/App.css";
import React from "react";

function UserAdminInformation(props) {
  const user = props.user || {};

  return (
    <div className="user-admin-information-container">
      <h2 className="subtitles">Datos: {user.name || ""}</h2>

      <label>Nombre completo</label>
      <input className="inp" type="text" disabled value={user.name || ""} />

      <label>Número de identificación</label>
      <input className="inp" type="number" disabled value={user.cedula ?? ""} />

      <label>Teléfono</label>
      <input className="inp" type="text" disabled value={user.phone || ""} />

      <label>Número de cliente</label>
      <input className="inp" type="text" disabled value={user.client_number || ""} />

      <label>Correo electrónico</label>
      <input className="inp" type="text" disabled value={user.email || ""} />

      <label>Edad</label>
      <input className="inp" type="number" disabled value={user.age ?? ""} />
    </div>
  );
}

export default UserAdminInformation;
